import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { getDetailUserProgram } from '../services/userPrograms'

export const getDetailProgramMember = createAsyncThunk('detail_program/getDetailProgramMember', async (programId) => {
  const response = await getDetailUserProgram(programId)
  return response
})

const detailProgram = createSlice({
  name: 'detail_program',
  initialState: {
    isLoadingProgram: true,
    data: null
  },
  reducers: {
    updateDataProgram: (state, action) => {
      state.isLoadingProgram = action.payload.isLoadingProgram
      state.data = action.payload.data
    }
  },
  extraReducers: {
    [getDetailProgramMember.pending]: (state) => {
      state.isLoadingProgram = true
    },
    [getDetailProgramMember.fulfilled]: (state, action) => {
      state.isLoadingProgram = false
      state.data = action.payload
    },
    [getDetailProgramMember.rejected]: (state) => {
      state.isLoadingProgram = false
      state.data = null
    }
  }
})

export const { updateDataProgram } = detailProgram.actions
export default detailProgram.reducer
